import cn from "classnames";
import { useBoolean } from "hooks";

import { ActionMessage } from "../../aiConversations.types";
import { AssistantAvatar } from "../AssistantAvatar";

import styles from "./ActionCard.module.scss";

interface Props {
  message: ActionMessage;
}

const EyeOff = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M2.5 2.5L17.5 17.5M8.13 8.13C7.74 8.52 7.5 9.06 7.5 9.66C7.5 10.86 8.47 11.83 9.67 11.83C10.27 11.83 10.81 11.59 11.2 11.2M13.91 13.9C12.66 14.6 11.33 15 10 15C6.25 15 3.13 11.88 1.88 9.38C2.53 8.08 3.48 6.94 4.63 6.05M7.13 4.2C8.03 3.91 8.98 3.75 10 3.75C13.75 3.75 16.88 6.88 18.13 9.38C17.71 10.2 17.13 10.97 16.44 11.67"
      stroke="#ea8c00"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Chevron = ({ open }: { open: boolean }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    style={{ transform: open ? "rotate(180deg)" : undefined, transition: "transform 0.2s" }}
  >
    <path
      d="M5 8l5 5 5-5"
      stroke="#090914"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ActionCard = ({ message }: Props) => {
  const { value: expanded, toggle } = useBoolean(false);

  return (
    <div className={styles.row}>
      <div className={styles.bubbleWrapper}>
        <div className={cn(styles.card, { [styles.cardExpanded]: expanded })}>
          <button type="button" className={styles.header} onClick={toggle}>
            <span className={styles.headerIcon}>
              <EyeOff />
            </span>
            <span className={styles.headerName}>{message.actionName}</span>
            <span className={styles.countTag}>x{message.count}</span>
            <span className={styles.statusTag}>{message.status}</span>
            <span className={styles.headerChevron}>
              <Chevron open={expanded} />
            </span>
          </button>

          {expanded && message.details && (
            <div className={styles.body}>{message.details}</div>
          )}
        </div>
        <div className={styles.time}>{message.time}</div>
      </div>

      <AssistantAvatar letter="A" size={24} />
    </div>
  );
};

export default ActionCard;
